import { config } from 'src/config'
import { getPostUrl } from 'src/data/mappers/post/getPostUrl'
import { getLanguageFromLocale } from 'src/functions/i18n/localeFns'

import type { Locale } from 'src/enum/Locale'
import type { CmsCanonical } from 'src/types/Canonical'
import type { PostType } from 'src/types/Post'

type LocaleSlug = {
  [key in Locale]?: string
}

export const getPostCanonicals = (localeSlugs: LocaleSlug, postLocale: Locale, postType: PostType): CmsCanonical[] => {
  const canonicals = []
  const defaultLocale = config.defaultLocales.xDefault as Locale

  // add tag for pointing to the base/original content page
  if (localeSlugs[postLocale]) {
    canonicals.push({
      rel: 'canonical',
      href: getPostUrl(localeSlugs[postLocale] as string, postLocale, postType),
    })
  }

  // add the x-default language
  if (localeSlugs[defaultLocale]) {
    canonicals.push({
      rel: 'alternate',
      href: getPostUrl(localeSlugs[defaultLocale] as string, defaultLocale, postType),
      hrefLang: 'x-default',
    })
  }

  Object.keys(localeSlugs).forEach((locale) => {
    canonicals.push({
      rel: 'alternate',
      href: getPostUrl(localeSlugs[locale as Locale] as string, locale as Locale, postType),
      hrefLang: getLanguageFromLocale(locale as Locale),
    })
  })

  return canonicals
}
